import Udesk from 'Udesk';

export function goFavoriteLink (id, scenario?) {
    window.open(getFavoriteLink(id, scenario));
}
export function getFavoriteLink (id, scenario?) {
    return `/sales/learning-center/words-mining/${scenario === Udesk.enums.applicationScenarios.sellingPoints.id ? 'selling-point' : 'dissent'}/favorite?id=${id}`;
}

